<template>
    <span class="fi fh fa-c ath-visual-icon" :class="[data.cname]" style="flex-shrink: 0;">
        <i v-if="data.uiIcon" aria-hidden="true" :class="[data.uiIcon]"></i>
    </span>
</template>

<script>
import { isNeString } from '@aretheyhappy/utils';

export default {
    name: 'mead-icon',
    props: {
        /**
         * Name of the icon to render. Accepts a bare linearicons name (auto-prefixed
         * with "lnr-") or a full class name already starting with "icon-", which is
         * left as-is. Defaults to `false`, which renders no icon glyph.
         */
        name: {type: [Boolean, String], default: () => false},
        /**
         * Size of the icon, applied as an `el--s-{uiSize}` class (e.g. "s", "m",
         * "l", "xl", "xxl", "giga", "massive").
         */
        uiSize: {type: String, default: () => 's'},
    },
    computed: {
        data: function () {
            return {
                cname   : `el--s-${this.uiSize}`,
                uiIcon  : isNeString(this.name)
                    ? `${this.name.startsWith('icon-') ? '' : 'lnr-'}${this.name.replace('lnr-', '')}`
                    : false,
            };
        },
    },
};
</script>

<style lang="scss" scoped>
@use '../../../../sass/variables' as *;

span {
    &.el--s-s i {
        font-size: $fs-s;
    }

    &.el--s-m i {
        font-size: $fs-m;
    }
    &.el--s-l i {
        font-size: $fs-l;
    }

    &.el--s-xl i {
        font-size: $fs-xl;
    }

    &.el--s-xxl i {
        font-size: $fs-xxl;
    }

    &.el--s-giga i {
        font-size: $fs-giga;
    }

    &.el--s-massive i {
        font-size: $fs-massive;
    }
}
</style>
